import { FC, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import useI18n from "../../../../../hooks/useTranslations";
import { useSubstructuresApi } from "../../../../../http/border/useSubstructures";
import FlexContent from "../../../../ui/FlexContent";
import Header from "../../../../ui/Header";
import { BORDER } from "../../AdminSystemSettings";
import SubstructureForm from "./SubstructureForm";

const EditSubstructure: FC = () => {
  const i18n = useI18n();
  const { systemId } = useParams<{ systemId: string }>();
  const { substructureId } = useParams<{ substructureId: string }>();
  const substructureApi = useSubstructuresApi();

  const aborter = useRef(new AbortController());
  const { data, error, isMutating, trigger } = substructureApi.getAdminSubstructure(
    substructureId!,
    aborter.current.signal,
  );

  const path = [
    { url: `/admin/systems`, display: i18n.translation.systems.all },
    { url: `/admin/systems/${systemId}`, display: BORDER },
    {
      url: `/admin/systems/${systemId}/settings?tab=2`,
      display: `${i18n.translation.common.settings}: ${i18n.translation.substructures.plural}`,
    },
    { display: data?.name ?? "" },
  ];

  useEffect(() => {
    substructureId && trigger();
  }, [substructureId]);

  return (
    <>
      <Header title={`${i18n.translation.substructures.singular}: ${data?.name ?? ""}`} error={error} path={path} />
      <FlexContent padding direction="row">
        <SubstructureForm
          substructure={!error ? data : undefined}
          isDisabled={isMutating || !!error}
          isLoading={!data && !error}
          tabbed
        />
      </FlexContent>
    </>
  );
};

export default EditSubstructure;
